/**
 * @copyright chuzhixin 1204505056@qq.com
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import { getSelf, login, logout, isLogin } from "@/api/user";
import { getList as getRoleList } from "@/api/role";
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from "@/utils/accessToken";
import { resetRouter } from "@/router";

const state = {
  accessToken: getAccessToken(),
  user: null,
  userid: "",
  username: "",
  name: "",
  phone: "",
  discribe: "",
  personType: 0,
  email: "",
  avatar: "",
  roles: [],
  permissions: [],
  refresh: 0,
};
const getters = {
  accessToken: (state) => state.accessToken,
  user: (state) => state.user,
  userid: (state) => state.userid,
  username: (state) => state.username,
  name: (state) => state.name,
  phone: (state) => state.phone,
  discribe: (state) => state.discribe,
  personType: (state) => state.personType,
  email: (state) => state.email,
  avatar: (state) => state.avatar,
  roles: (state) => state.roles,
  permissions: (state) => state.permissions,
  refresh: (state) => state.refresh,
};
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
    setAccessToken(accessToken);
  },
  setUser(state, user) {
    state.user = user;
  },
  setUserid(state, userid) {
    state.userid = userid;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setName(state, name) {
    state.name = name;
  },
  setPhone(state, phone) {
    state.phone = phone;
  },
  setPersonType(state, personType) {
    state.personType = personType;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setDiscribe(state, discribe) {
    state.discribe = discribe;
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setRefresh(state, refresh) {
    state.refresh = refresh;
  },
};
const actions = {
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  setPermissions({ commit }, permissions) {
    commit("setPermissions", permissions);
  },
  setRefresh({ commit }, refresh) {
    commit("setRefresh", refresh);
  },
  async login({ commit }, loginInfo) {
    const { data } = await login(loginInfo);
    const status = data.data;
    console.log(data)
  },
  loginSuccess({ commit }, userInfo) {
    const { data } = userInfo
    const item = data
    if (item === null || item === undefined) {
      return null
    }
    let permissions = []
    let len = item.permission.length
    if (len > 0) {
      for (let i=0; i<len; i++) {
        permissions.push(item.permission[i].id)
      }
    } else {
      permissions.push(0)
    }
    let roles = []
    let total = item.role.length
    if (total > 0) {
      for (let j=0; j<total; j++) {
        roles.push(item.role[j].id)
      }
    } else {
      roles.push(0)
    }
    
    // this.updateRole(roles);
    // console.log(permissions)
    // console.log(data)
    commit("setAccessToken", "admin-accessToken");
    commit("setUser", item);
    commit("setRoles", item.role);
    commit("setPermissions", permissions);
    commit("setUserid", item.id);
    commit("setUsername", item.username);
    commit("setName", item.name);
    commit("setPhone", item.phone);
    commit("setDiscribe", item.remark);
    commit("setPersonType", item.personType);
    commit("setEmail", item.email);
    commit("setAvatar", item.avatar);
    
    // const query = {
    //   limit: 1000,
    //   page: 1
    // }
    // getRoleList(query).then(response => {
    //   const { data } = response
    //   console.log(data)
    //   let permissionId = []
    //   const count = data.data.total
    //   const items = data.data.items
    //   console.log(items)
    //   for (let i=0; i<count; i++) {
    //     for (let j=0; j<roles.length; j++) {
    //       if (roles[j] === items[i].id) {
    //         let permissionList = items[i].permissionList
    //         for (let k=0; k<permissionList.length; k++) {
    //           permissionId.push(permissionList[k].id)
    //         }
    //       }
    //     }
    //   }
    //   let permissionIdArray = permissionId.filter(function(item,index){
    //     return permissionId.indexOf(item,0) === index;
    //   });
    //   console.log(permissionIdArray)
    //   if (permissionId.length > 0) {
    //     commit("setPermissions", permissionIdArray);
    //   }
    // }).catch(function(error) {
    //   console.error(error)
    // })

    return permissions;
  },
  async getUserInfo({ commit, state }) {
    const { data } = await getSelf();
    const item = data.data
    if (item === null || item === undefined) {
      return null
    }
    console.log(data)
    let permissions = []
    let len = item.permission.length
    // console.log(len)
    if (len > 0) {
      for (let i=0; i<len; i++) {
        permissions.push(parseInt(item.permission[i].id))
      }
    } else {
      return null
      // permissions.push(0)
      console.log('0')
    }
    let roles = []
    let total = item.role.length
    if (total > 0) {
      for (let j=0; j<total; j++) {
        roles.push(item.role[j].id)
      }
    } else {
      roles.push(0)
    }
    // this.updateRole(roles);
    console.log(permissions)
    commit("setAccessToken", "admin-accessToken");
    commit("setUser", item);
    commit("setUserid", item.id);
    commit("setUsername", item.username);
    commit("setName", item.name);
    commit("setPhone", item.phone);
    commit("setEmail", item.email);
    commit("setDiscribe", item.remark);
    commit("setRoles", item.role);
    commit("setPermissions", permissions);
    commit("setPersonType", item.personType);
    commit("setAvatar", item.avatar);
    
    
    // const query = {
    //   limit: 1000,
    //   page: 1
    // }
    // const { back } = getRoleList(query);
    
    // let permissionId = []
    // const count = back.total
    // const items = back.items
    // console.log(items)
    // for (let i=0; i<count; i++) {
    //   for (let j=0; j<roles.length; j++) {
    //     if (roles[j] === items[i].id) {
    //       let permissionList = items[i].permissionList
    //       for (let k=0; k<permissionList.length; k++) {
    //         permissionId.push(permissionList[k].id)
    //       }
    //     }
    //   }
    // }
    // let permissionIdArray = permissionId.filter(function(item,index){
    //   return permissionId.indexOf(item,0) === index;
    // });
    // console.log(permissionIdArray)
    // if (permissionId.length > 0) {
    //   commit("setPermissions", permissionIdArray);
    // }
    
    return permissions;
  },
  async isLogin() {
    const { data } = await isLogin();
    if (data.data === true) {
      return true
    }
    return false
  },
  async logout({ dispatch }) {
    await dispatch("resetAccessToken");
    await resetRouter();
    logout();
  },
  resetAccessToken({ commit }) {
    commit("setRefresh", 0);
    commit("setPermissions", []);
    commit("setAccessToken", "");
    removeAccessToken();
  },
};
export default { state, getters, mutations, actions };
